// extracted by mini-css-extract-plugin
module.exports = {"container":"Title-module__container___1vnN_","title":"Title-module__title___J3TVA","updatedAt":"Title-module__updatedAt___2sTwp"};